// TRASLADOS SIN SEÑAL · DIRECTRIZ-PWA F2 (11 oct 2026, DISENO-F2 §4.6).
//
// Dos acciones viajan por aquí: MANDAR mercancía (`POST /traslados`) y
// RECIBIRLA (`POST /traslados/{id}/recibir`). Las dos llevan la misma
// `clave_idempotencia` que nace en `colaBase` antes del primer intento y
// se repite en cada reenvío; el servidor la respeta en las dos (la del
// envío desde la 068, la de la recepción desde la 902: un reenvío devuelve
// lo ya aplicado en vez de un 409 falso, R-PWA-12).
//
// QUÉ NO VA POR AQUÍ: cancelar («Se dio la vuelta»). Cancelar lo que el
// servidor quizá ya recibió es un conflicto que se resuelve con señal.
import { api } from '../api';
import { crearCola, cargaDe, PENDIENTE, POR_REVISAR, ENVIADA } from './colaBase';

export const ENVIAR = 'ENVIAR';
export const RECIBIR = 'RECIBIR';

function resumen(cuerpo, extra) {
  if (extra.accion === RECIBIR) {
    return {
      accion: RECIBIR, id_traslado: extra.id_traslado, folio: extra.folio ?? null,
      origen: extra.origen ?? null, destino: extra.destino ?? null,
      renglones: (cuerpo.renglones || []).length,
    };
  }
  const renglones = cuerpo.renglones || [];
  return {
    accion: ENVIAR,
    origen: cuerpo.ubicacion_origen, destino: cuerpo.ubicacion_destino,
    referencia: cuerpo.referencia ?? null,
    renglones: renglones.length,
    unidades: renglones.reduce((s, r) => s + Number(r.cantidad || 0), 0),
  };
}

const cola = crearCola({
  db: 'tego-traslados',
  store: 'traslados',
  resumen,
  enviar: (e) => (e.accion === RECIBIR
    ? api.post(`/traslados/${e.id_traslado}/recibir`, cargaDe(e))
    : api.post('/traslados', cargaDe(e))),
  alEnviada: (e, r) => ({ folio: r?.folio ?? e.folio ?? null, respuesta_mensaje: r?.mensaje ?? null }),
});

/**
 * Manda mercancía. Devuelve
 *   {estado:'aplicado', respuesta}  — ya salió en TEGO
 *   {estado:'encolado', elemento}   — guardado en este teléfono
 * Lanza el ErrorApi si el servidor lo rechaza por regla.
 */
export function registrarTraslado(idUsuario, cuerpo) {
  return cola.registrar(idUsuario, cuerpo, { accion: ENVIAR });
}

/** Recibe un traslado. Misma forma que `registrarTraslado`. */
export function recibirTraslado(idUsuario, idTraslado, cuerpo, datos = {}) {
  return cola.registrar(idUsuario, cuerpo, {
    accion: RECIBIR, id_traslado: idTraslado,
    folio: datos.folio ?? null, origen: datos.origen ?? null, destino: datos.destino ?? null,
  });
}

/** Lo guardado de esta persona (PENDIENTE, POR_REVISAR y ENVIADA de hoy). */
export const listarTraslados = (idUsuario, opciones) => cola.listar(idUsuario, opciones);

/** Lo que falta por enviar, con su `resumen` para pintar la fila local. */
export const pendientesTraslado = (idUsuario) => cola.listar(idUsuario, { estado: PENDIENTE });

export const contarPendientesTraslado = (idUsuario) => cola.contar(idUsuario);
export const contarTrasladosPorRevisar = (idUsuario) => cola.contarPorRevisar(idUsuario);
export const contarTrasladosDeOtraCuenta = (idUsuario) => cola.contarDeOtraCuenta(idUsuario);

/** Los ids de traslado con una recepción guardada sin enviar. */
export async function trasladosConRecepcionPendiente(idUsuario) {
  const salida = new Set();
  for (const e of await pendientesTraslado(idUsuario)) {
    if (e.accion === RECIBIR) salida.add(e.id_traslado);
  }
  return salida;
}

export const sincronizarTraslados = (idUsuario) => cola.reintentar(idUsuario);
export const enviarTrasladoAhora = (clave) => cola.enviarAhora(clave);
export const descartarTraslado = (clave) => cola.descartar(clave);
export const suscribirTraslados = (fn) => cola.suscribir(fn);

export { PENDIENTE, POR_REVISAR, ENVIADA };
